export const LIMITS_TYPE = 'loginTime';

export const LIMIT_TYPES = {
    LOGIN_COUNT: 1,
    DAILY_LIMIT: 2,
    BAN_ON_BET_AFTER_LOGOUT: 3,
    WEEKLY_LIMIT: 4,
    MONTHLY_LIMIT: 5
};

export const LIMIT_FIELD_NAMES = {
    [LIMIT_TYPES.LOGIN_COUNT]: 'monthlyLoginCount',
    [LIMIT_TYPES.DAILY_LIMIT]: 'dailyLoginTime',
    [LIMIT_TYPES.WEEKLY_LIMIT]: 'weeklyLoginTime',
    [LIMIT_TYPES.MONTHLY_LIMIT]: 'monthlyLoginTime'
};

export const LIMIT_FIELD_PERIODS = {
    [LIMIT_TYPES.DAILY_LIMIT]: 'day',
    [LIMIT_TYPES.WEEKLY_LIMIT]: 'week',
    [LIMIT_TYPES.MONTHLY_LIMIT]: 'month'
};

export const LIMIT_FIELD_EXTRA_DATA = {
    [LIMIT_TYPES.LOGIN_COUNT]: {
        label: 'fields.countLabel',
        placeholder: 'fields.countPlaceholder',
        pendingLabel: 'pendingFields.countLabel'
    },
    [LIMIT_TYPES.DAILY_LIMIT]: {
        label: 'fields.dailyLabel',
        placeholder: 'fields.dailyPlaceholder',
        pendingLabel: 'pendingFields.dailyLabel'
    },
    [LIMIT_TYPES.WEEKLY_LIMIT]: {
        label: 'fields.weeklyLabel',
        placeholder: 'fields.weeklyPlaceholder',
        pendingLabel: 'pendingFields.weeklyLabel'
    },
    [LIMIT_TYPES.MONTHLY_LIMIT]: {
        label: 'fields.monthlyLabel',
        placeholder: 'fields.monthlyPlaceholder',
        pendingLabel: 'pendingFields.monthlyLabel'
    }
};

export const UNLIMITED_STR = '9223372036854775807';
export const UNLIMITED = Number(UNLIMITED_STR);
